function openCartDrawer(cartData, shouldAnimate = true) {
  const drawer = document.getElementById('lift-cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  const header = document.querySelector('.cart-drawer__header');
  const footer = document.querySelector('.cart-drawer__footer');
  const itemsContainer = document.getElementById('lift-cart-drawer-items');
  const subtotalElement = document.getElementById('lift-cart-drawer-subtotal');

  itemsContainer.innerHTML = '';

  // detect currency
  const currencyCode =
    (cartData && cartData.currency) ||
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    'GBP';

  const money = new Intl.NumberFormat('en', { style: 'currency', currency: currencyCode });

  if (!cartData || !cartData.items || cartData.items.length === 0) {
    
    header.style.display = 'none';
    footer.style.display = 'none';
    itemsContainer.innerHTML = `
      <tr>
        <td colspan="4" style="text-align:center; padding: 40px 20px;">
          <img src="https://cdn.shopify.com/s/files/1/0964/0486/5373/files/delete.png?v=1753447281"
               alt="Empty Cart" style="width:170px; opacity:0.6; margin-bottom:20px;">
          <div style="font-size:32px; font-weight:700; margin-bottom:20px;">Your cart is empty</div>
          <div style="font-size:16px; color:#838282;">Add products to your cart.</div>
          <br>
          <button onclick="closeCartDrawer()" class="bundle-cta-button btn hover-filled-slide-up btn-1 cart_close_btn">
            <span>Close</span>
          </button>
        </td>
      </tr>`;
      subtotalElement.textContent = money.format(0);
  } else {
    header.style.display = '';
    footer.style.display = '';
    let html = '';
    let customTotal = 0;
    cartData.items.forEach((item, index) => {
      const rawCustom = item.properties?.['Custom Price'];
      const parsedCustom = rawCustom ? parseFloat(String(rawCustom).replace(/[^\d.]/g, '')) : null;
      const unitPrice = parsedCustom ?? (item.final_line_price / item.quantity / 100);
      const lineTotal = unitPrice * item.quantity;
      customTotal += lineTotal;
      // const itemPrice = (item.final_line_price / 100).toFixed(2);
      const productImage = item.image
        ? `<img src="${item.image}" alt="${item.title}" style="object-fit:cover; width:46px; height:69px;">`
        : '';

      const planSubtitle = item.properties?.["Subscription Plan"]
        ? `<div class="cart-product-subtitle">${item.properties["Subscription Plan"]}</div>`
        : '';

      html += `
        <tr>
          <td>
            <div class="cart-product-info">
              ${productImage}
              <div>
                <div class="cart-product-title">${item.product_title}</div>
                ${planSubtitle}
                <button onclick="removeCartItem('${item.key}')" class="cart-remove for_mobile">Remove</button>
              </div>
            </div>
          </td>

          <td>
            <div class="custom-select-wrapper">
              <select onchange="updateCartQuantity(${index + 1}, this.value)">
                ${[...Array(10)].map((_, i) =>
                  `<option value="${i + 1}" ${item.quantity === i + 1 ? 'selected' : ''}>${i + 1}</option>`
                ).join('')}
              </select>
            </div>
            <span class="price_mobile" style="font-size:18px; font-weight:500;">${money.format(unitPrice)}</span>
          </td>

          <td class="" style="font-size:18px; font-weight:500;">
          <span class="price_dev" style="font-size:18px; font-weight:500;">${money.format(unitPrice)}</span>
          </td>

          <td>
            <button onclick="removeCartItem('${item.key}')" class="cart-remove for_dev">Remove</button>
          </td>
        </tr>`;
    });

    itemsContainer.innerHTML = html;
    subtotalElement.textContent = money.format(customTotal);
  }

  // Show
  drawer.classList.remove('hidden');
  overlay.classList.remove('hidden');

  // Animate cart drawer with GSAP
  if (typeof gsap !== 'undefined' && shouldAnimate) {
    gsap.fromTo(drawer, { x: '100%', opacity: 0 }, { x: '0%', opacity: 1, duration: 0.5, ease: 'power3.out' });
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('lift-cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');

  if (typeof gsap !== 'undefined') {
    gsap.to(drawer, {
      x: '100%', opacity: 0, duration: 0.5, ease: 'power2.in',
      onComplete: () => drawer.classList.add('hidden')
    });
    gsap.to(overlay, {
      opacity: 0, duration: 0.5,
      onComplete: () => overlay.classList.add('hidden')
    });
  } else {
    drawer.classList.add('hidden');
    overlay.classList.add('hidden');
  }
}

function showLoader() {
  const loader = document.getElementById('cart-loader');
  if (loader) loader.style.display = 'flex';
}
function hideLoader() {
  const loader = document.getElementById('cart-loader');
  if (loader) loader.style.display = 'none';
}

function addToCartAndOpenDrawer(variantId, quantity = 1, properties = {}) {
  if (!variantId) { alert("Invalid variant selected."); return; }
  showLoader();
  console.log("variantId : ", variantId);
    console.log("properties :", properties);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
    .then(res => res.ok ? res.json() : res.json().then(err => Promise.reject(err)))
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => { hideLoader(); openCartDrawer(cart, true); })
    .catch(err => { hideLoader(); alert(err?.description || 'Failed to add to cart.'); console.error(err); });
}

function checkStockAndAdd(variantId, quantity = 1, properties = {}) {
  showLoader();
  fetch(`/variants/${variantId}.js`)
    .then(res => res.ok ? res.json() : Promise.reject("Invalid variant."))
    .then(variant => {
      if (!variant.available) { hideLoader(); alert("This product is sold out."); return; }
      addToCartAndOpenDrawer(variantId, quantity, properties);
    })
    .catch(err => { hideLoader(); alert("Error checking product stock."); console.error(err); });
}

function updateCartQuantity(line, quantity) {
  showLoader();
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity: parseInt(quantity, 10) })
  })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => { hideLoader(); openCartDrawer(cart, false); })
    .catch(() => hideLoader());
}

function removeCartItem(lineItemKey) {
  showLoader();
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => { hideLoader(); openCartDrawer(cart, false); })
    .catch(() => hideLoader());
}

function getSelectedPlanTitle() {
  const selectedPlan = document.querySelector('.plan-card.selected .plan-header');
  return selectedPlan ? selectedPlan.textContent.trim() : 'Default Plan';
}

document.addEventListener('DOMContentLoaded', function () {
  const headerMenu = document.querySelector('a#HeaderMenu-cart');
  const mobile_cart_icon = document.getElementById('gad_cart_icon_header');

  // Add to Cart buttons
  const allButtons = document.querySelectorAll('[id^="btn-add-to-cart-"]');
  allButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');
      const properties = { "Subscription Plan": getSelectedPlanTitle() };
      checkStockAndAdd(variantId, 1, properties);
    });
  });

  // Open drawer on cart icon
  function handleCartClick(e) {
    e.preventDefault();
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => openCartDrawer(cart))
      .catch(err => console.error("Error loading cart:", err));
  }
  if (headerMenu) headerMenu.addEventListener('click', handleCartClick);
  if (mobile_cart_icon) mobile_cart_icon.addEventListener('click', handleCartClick);
});
